import * as actionTypes from '@store/actions/actionTypes'

const initialState = {
  modal: null
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_MODAL:
      return {
        ...state,
        modal: action.modal
      }
    default:
      return state
  }
}

export default reducer
